import gql from "graphql-tag";

export default gql(`
mutation ($input: DeleteAnswerInput!){
    deleteAnswer(input: $input) {
        id
        answer
    }
}`);